import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export default function useTeachers({ schoolId }) {
  return useQuery({
    enabled: !!schoolId,
    placeholderData: [],
    queryKey: [],
    queryFn: () => (
      axios.get(`/students/teachers?school_id=${schoolId}`)
        .then((res) => (
          [...new Set(res.data.data.map((teacher) => teacher.name))]
        ))
    ),
  });
}
